import Vue from 'vue'
import VueRouter from 'vue-router';
import App from './App.vue'
import {routes} from './routes';
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import store from './store/store';
import HighChartsVue from 'highcharts-vue'
Vue.use(VueRouter);

Vue.use(BootstrapVue);
Vue.use(HighChartsVue);
const router = new VueRouter({
  mode : 'hash',
  routes
});

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js